module.exports = __webpack_public_path__ + "static-portal/img/SES.f21c7d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SES.png
// module id = 7C3j
// module chunks = 4